// extracted by mini-css-extract-plugin
export default {"btn":"style_btn__FPFtK","btn_text":"style_btn_text__HEISL"};